// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconLogout = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      className: 'ionicon',
      viewBox: '0 0 512 512',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M304 336v40a40 40 0 01-40 40H104a40 40 0 01-40-40V136a40 40 0 0140-40h152c22.09 0 48 17.91 48 40v40M368 336l80-80-80-80M176 256h256',
      fill: 'none',
      stroke: 'current',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: '32'
    })
  );

export { IconLogout };
